import { useMemo } from 'react';
import { createPortal } from 'react-dom';
import { decimalString } from 'src/constants/types';

import { useOutSideClick } from 'src/hooks/outSideClick';

import './style.scss';

const buttons: decimalString[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0'];

export interface IProps {
    customButtons?: decimalString[];
    isMobile?: boolean;
    onClick(value: decimalString, isCustomButton?: boolean): void;
    onRemove(): void;
    onClose(): void;
    outsideException?: string,
}

const NumericKeyboard = ({ customButtons, onClick, onRemove, onClose, outsideException, isMobile }: IProps) => {
    const ref = useOutSideClick(onClose, [onClose], outsideException);
    const betslipContainer = useMemo(() => document.querySelector('.B-betslip-wrapper'), []);
    const betslipPopupContainer = useMemo(() => document.querySelector('.B-popup-wrapper'), []);

    const containerByPriority = betslipPopupContainer || betslipContainer;

    if (!containerByPriority) return null;

    return (
        <>
            {createPortal(
                <div ref={ref} className={`B-betslip-numeric-keyboard ${isMobile ? 'B-betslip-mobile-numeric-keyboard' : ''}`}>
                    <div className='calc-top-section'>
                        {customButtons?.map(item => (
                            <button key={item} onClick={() => onClick(item, true)}>{item}</button>
                        ))}
                    </div>
                    <div className='calc-action-buttons'>
                        {buttons.map(item => (
                            <button key={item} onClick={() => onClick(item)}>{item}</button>
                        ))}
                        <button onClick={onRemove} className="global-icon icon-backspace" />
                    </div>
                    <div className='for-done-button'>
                        <button onClick={onClose}> <span className="global-icon icon-icon-done" /></button>
                    </div>
                </div>,
                containerByPriority
            )}
        </>
    );
};

export default NumericKeyboard;
